// Central, editable company configuration — the single source of truth.
// Empty strings are intentional: the UI hides any field that is empty.
// CMS company settings (Admin → Settings → Company) override these at runtime.

export const COMPANY = {
  name: "Aviah Financial",
  legalName: "Aviah Financial",
  founder: "Escarling Martínez",
  founderRole: { en: "Founder & CEO", es: "Fundadora y CEO" },
  phone: "(407) 340-9141",
  phoneHref: "tel:+14073409141",
  email: "", // NOT PROVIDED YET — hidden everywhere until supplied
  address: {
    street: "6900 Tavistock Lakes Blvd",
    suite: "Suite 400",
    city: "Orlando",
    state: "FL",
    zip: "32827",
    mapsQuery:
      "https://www.google.com/maps/search/?api=1&query=6900+Tavistock+Lakes+Blvd+Suite+400+Orlando+FL+32827",
    mapsEmbed:
      "https://www.google.com/maps?q=6900+Tavistock+Lakes+Blvd+Suite+400+Orlando+FL+32827&output=embed",
  },
  officeHours: {
    days: { en: "Monday – Friday", es: "Lunes – Viernes" },
    open: "9:00 AM",
    close: "5:00 PM",
  },
  appointmentRequired: true,
  serviceArea: { en: "Orlando, Florida", es: "Orlando, Florida" },
  social: {
    instagram: "",
    facebook: "",
    tiktok: "",
    linkedin: "",
  },
};

// Editable credential wording. Do NOT imply government endorsement, CPA
// status or law-firm status unless verified before publication.
export const CREDENTIALS = {
  en: [
    "Business Administration",
    "Accounting / Financial Experience",
    "Certified Acceptance Agent — ITIN",
  ],
  es: [
    "Administración de Empresas",
    "Experiencia Contable / Financiera",
    "Agente Tramitador Certificado — ITIN",
  ],
};

export const CREDENTIALS_NOTE = {
  en: "Credentials reflect individual professional qualifications described by the firm. Final wording is verified before publication.",
  es: "Las credenciales reflejan las cualificaciones profesionales individuales descritas por la firma. La redacción final se verifica antes de su publicación.",
};

// Bundled fallback imagery (temporary demo photography — CMS image slots win).
const U = "https://images.unsplash.com/";
const Q = "?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";

export const IMAGES = {
  hero: U + "photo-1765323337815-1b1c1a47cdaa" + Q + "&w=2000",
  staircase: U + "photo-1601993957728-1e56ab70c5a8" + Q,
  marble: U + "photo-1765371512612-86600e661f4d" + Q,
  office: U + "photo-1758598306980-c47a94c6708c" + Q,
  meeting: U + "photo-1551836022-d0b54d686dd0" + Q,
  leader: U + "photo-1605404991190-ee36da15632c" + Q,
  workspace: U + "photo-1629726343583-d9718b3e8f3f" + Q,
  laptop: U + "photo-1590650153855-d9e808231d41" + Q,
};

export const LOGOS = {
  white: "/assets/logo-white.webp",
  black: "/assets/logo-black.webp",
  gold: "/assets/logo-gold.webp",
};
